import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { API_SURVEY_QUESTIONS } from '@/api/endpoints';
import { SURVEY_QUESTION_QUERY_KEY } from '@/api/queryKeys';
import { toSurveyFillQuestion } from '@/pages/Mail/surveys';
import type {
  SurveyFillQuestion,
  SurveyQuestionResponse,
} from '@/types/survey';
import { unwrapAxiosResponse } from '@/utils/axios';
import { joinPath } from '@/utils/global';

export const useSurveyQuestion = (questionId: string | null) =>
  useQuery<SurveyFillQuestion>({
    queryKey: [...SURVEY_QUESTION_QUERY_KEY, questionId],
    enabled: !!questionId,
    staleTime: Infinity,
    queryFn: () =>
      apiClient
        .get<SurveyQuestionResponse>(
          joinPath(API_SURVEY_QUESTIONS, questionId!),
        )
        .then(unwrapAxiosResponse)
        .then(toSurveyFillQuestion),
  });
